export default "__VITE_ASSET__D2Cg7T____"